import React from "react";
import styled from "styled-components";
import * as colors from "../../../assets/_base/colors"
import Text from "../../../_components/Text";
const GlassContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    /* From https://css.glass */
    background-color: ${colors.lightBlue};
    border-radius: 16px;
    box-shadow: 0 4px 30px ${colors.lightCyan};
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 3px solid rgba(255, 255, 255, 0.3);
    padding: 20px;
    margin: 10px;
    cursor: pointer;
    transition: all .1s;

    * {
        color: white;
    }

    i {
        font-size: 1.4em;
        margin-bottom: 20px;
    }
    :hover{
        border: 4px solid rgba(255, 255, 255, 0.3);
    }

`

export default props => {
    function redirect(path){
        window.location.href = path
    }
    return <div className="container">
        <div className="row py-3">
            <div className="col-12">
                <Text as="h1">
                    Classes de impostos
                </Text>
            </div>
        </div>
        <div className="row">
            <div className="col-md-3">
                <GlassContainer
                    onClick={() => redirect("/products/taxes/icms")}>
                    <i className="fas fa-balance-scale" />
                    <h1>
                        ICMS
                    </h1>
                </GlassContainer>
            </div>
            <div className="col-md-3">
                <GlassContainer onClick={() => redirect("/products/taxes/ipi")} >
                    <i className="fas fa-balance-scale" />
                    <h1>
                        IPI
                    </h1>
                </GlassContainer>
            </div>
            <div className="col-md-3">
                <GlassContainer onClick={() => redirect("/products/taxes/pis")}>
                    <i className="fas fa-balance-scale" />
                    <h1>
                        PIS
                    </h1>
                </GlassContainer>
            </div>
            <div className="col-md-3">
                <GlassContainer onClick={() => redirect("/products/taxes/cofins")}>
                    <i className="fas fa-balance-scale" />
                    <h1>
                        COFINS
                    </h1>
                </GlassContainer>
            </div>
        </div>
    </div>
} 


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/index.jsx